export default __webpack_public_path__ + "static/media/parks.9c2b1d58.jpg";